import {RegistrationToastMessage} from "./RegistrationToastMessage";
import {HelperText, MobileNumberSection, TabFormSection, TabsSection} from "./Styled";
import React, {useCallback, useState} from "react";

import EmailField from "./Fields/EmailField";
import PasswordField from "./Fields/PasswordField";

import NameField from "./Fields/NameField";
import SocialSignUp from "./SocialSignUp";
import {
    FieldData,
    RegistrationFields,
    FormType,
} from "../../../containers/RegistrationLoginPage/types";
import CountryCodeField from "./Fields/CountryCodeField";
import MobileNumberField from "./Fields/MobileNumberField";
import UserCityField from "./Fields/UserCityField";
import FieldWrapper from "./FieldWrapper";
import {FormUl} from "./loaderStyled";
import UserImage from "./UserImage";
import {useSelector} from "react-redux";
import {RootStore} from "../../../configureStore";
import TrueCallerPopup from "./SocialSignUp/TrueCaller";
import {getPageType} from "../../../containers/RegistrationLoginPage/utils";
import {useLocation} from "react-router";

interface PersonalDetails {
    fields?: FieldData;
    values: RegistrationFields;
    formType: FormType;
    cropSize: {width: number; height: number};
}

const userCityFieldConditionHandler = (value: {[key: string]: {id: number}}) => {
    if (value.countryCode && value?.countryCode?.id !== 2) {
        return false;
    }

    return true;
};

const PersonalDetails: React.FC<PersonalDetails> = ({
    fields,
    formType,
    cropSize,
}: PersonalDetails) => {
    //const PasswordFieldHandler = WithConditionalFieldVisibility(PasswordField);
    const signupOptions = fields?.signupOption.values ?? [];
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const location = useLocation();
    // handling true caller functionality on registration page
    const [trueCallerSDK, setTrueCallerSDK] = useState<boolean>(false);

    const mobileOnClickHandler = useCallback(
        (sdkFlag: boolean) => {
            if (sdkFlag && isMobile) {
                setTrueCallerSDK(sdkFlag);
            }
        },
        [setTrueCallerSDK, isMobile],
    );

    const {pathname} = location;
    const {pageStatus} = getPageType(pathname);
    const {isUserEditProfile, isMMP} = pageStatus;

    return (
        <TabsSection>
            {!isMobile && (
                <>
                    <h2>1. Personal details</h2>
                    <span>
                        This will create your account and enable you to receive recommendations (you
                        can opt-out anytime)
                    </span>
                </>
            )}
            {signupOptions.includes("google") && !isMMP && <SocialSignUp />}
            {fields?.image.visible && <UserImage cropSize={cropSize} />}
            <TabFormSection>
                <FormUl>
                    {fields?.email && (
                        <FieldWrapper visible={fields.email.visible}>
                            <EmailField configuration={fields.email} />
                        </FieldWrapper>
                    )}

                    {fields?.password && (
                        <FieldWrapper visible={fields.password.visible}>
                            <PasswordField
                                configuration={fields.password}
                                formType={formType}
                                hiddenText={!isMobile}
                            />
                        </FieldWrapper>
                    )}

                    {fields?.name && (
                        <FieldWrapper visible={fields.name.visible}>
                            <NameField configuration={fields.name} />
                        </FieldWrapper>
                    )}
                    {fields?.countryCode && (
                        <FieldWrapper visible={fields.countryCode.visible}>
                            <MobileNumberSection>
                                <CountryCodeField configuration={fields.countryCode} />
                                <MobileNumberField
                                    configuration={fields.mobileNumber}
                                    mobileOnClickHandler={mobileOnClickHandler}
                                    isCheckMobileExist={!isUserEditProfile && true}
                                />
                            </MobileNumberSection>
                            <HelperText>One time passcode will be sent to this number</HelperText>
                        </FieldWrapper>
                    )}

                    {fields?.userCity && (
                        <FieldWrapper
                            visible={fields.userCity.visible}
                            whenFields={["countryCode"]}
                            //@ts-expect-error type correction needed
                            fieldConditionHandler={
                                fields.userCity.visible && userCityFieldConditionHandler
                            }
                        >
                            <UserCityField configuration={fields.userCity} />
                        </FieldWrapper>
                    )}
                </FormUl>
            </TabFormSection>
            <RegistrationToastMessage />
            {trueCallerSDK && <TrueCallerPopup isRegistrationPage={true} />}
        </TabsSection>
    );
};

export default PersonalDetails;
